class ChasePaymentUkRequest {
    public preauth!: boolean;
    public amount!: number;
    public customerId?: string;
    public restaurantId?: number;
    public tokenId?: number
}

export { ChasePaymentUkRequest };